export const getDefaultValues = (gameEntryFeeRewardDetails) => ({
  GameEntryFeeRewardsGameID: gameEntryFeeRewardDetails?.GameEntryFeeRewardsGameID || '',
  GameEntryFeeRewardsTransactionAmountTypeID: gameEntryFeeRewardDetails?.GameEntryFeeRewardsTransactionAmountTypeID || 0,
  GameEntryFeeRewardsScore: gameEntryFeeRewardDetails?.GameEntryFeeRewardsScore || '',
  GameEntryFeeRewardsAmount: gameEntryFeeRewardDetails?.GameEntryFeeRewardsAmount || '',
});
